import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { QueryClientProvider } from "react-query";
import { queryClient } from "../services/queryClient";
import { Home } from "../pages/Home";


export function Pages() {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
        if (!isAuthenticated) {
            instance.ssoSilent({
                scopes: []
            }).then((response) => {
                instance.setActiveAccount(response.account);
            }).catch(error => {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.loginRedirect();
                }
            });
        }
    

    return (
        <>
            <QueryClientProvider client={queryClient}>
                <AuthenticatedTemplate>
                    <Home />
                </AuthenticatedTemplate>
            </QueryClientProvider>
        </>
    )
}
